import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'

export default class extends Controller {
  static targets = ['entity']

  static values = {
    busItemId: String
  }

  connect() {
    useBusItem(this)
  }

  get selectedEntitiesIds() {
    const selectedEntitiesIds = []

    this.entityTargets.forEach(entityTarget => {
      if (entityTarget.checked) {
        selectedEntitiesIds.push(this.getEntityId(entityTarget.id))
      }
    })

    return selectedEntitiesIds
  }

  getEntityId(id) {
    return id.split('-')[0]
  }

  disconnect() {
    this.removeFromBus()
  }
}
